import ordertracking from '../../assets/apps/ordertracking.png';
import pagefly from '../../assets/apps/pagefly.png';
import blockify from '../../assets/apps/blockify.png';
import facebookpixel from '../../assets/apps/facebookpixel.png';
import requestaquote from '../../assets/apps/requestaquote.jpg';
import smsg from '../../assets/apps/smsg.jpg';
import vsali from '../../assets/apps/vsali.png';
import roartheme from '../../assets/apps/roartheme-logo.jpg';
import b2b from '../../assets/apps/b2b.png';
import bogo from '../../assets/apps/bogo.png';
import litcommerce from '../../assets/apps/litcommerce.png';
import returnsDrive from '../../assets/apps/ReturnsDriveLogo.png';

export const configRecommend = [
  {
    title: 'Omega ‑ Returns & Exchanges',
    brand: '',
    description:
      'Streamline returns, exchanges, refunds to delight customers & retain revenue',
    plan: 'Free',
    star: '5.0',
    review: '',
    img: returnsDrive,
    href: 'https://apps.shopify.com/omega-returns-drive?locale=fr&surface_detail=inapprcm&surface_type=ST',
  },
  {
    title: 'Omega - Order Tracking',
    brand: '',
    description: 'Order Lookup, Track Order Status,...',
    plan: 'Free plan available',
    star: '4.9',
    review: '107',
    img: ordertracking,
    href: 'https://apps.shopify.com/omega-order-tracking?surface_detail=synctrack&surface_type=recommendedapp',
  },
  {
    title: 'Pagefly - Landing page builder',
    brand: '',
    description: 'Build Landing, Product Pages...',
    plan: 'Free plan available',
    star: '4.9',
    review: '6458',
    img: pagefly,
    href: 'https://pagefly.link/yvAQEqZG',
  },
  {
    title: 'Blockify ‑ IP Block',
    brand: '',
    description: 'Block or redirect visitors by IPs,...',
    plan: '3-day free trial',
    star: '4.7',
    review: '48',
    img: blockify,
    href: 'https://apps.shopify.com/region-restrictions?surface_detail=synctrack&surface_type=recommendedapp',
  },
  {
    title: 'Omega ‑ Multi Facebook Pixels',
    brand: '',
    description: 'Multi Pixels, S2S Conversion API,...',
    plan: '7-day free trial',
    star: '4.9',
    review: '353',
    img: facebookpixel,
    href: 'https://apps.shopify.com/facebook-multi-pixels?surface_detail=synctrack&surface_type=recommendedapp',
  },
  {
    title: 'SMSGem ‑ SMS Marketing',
    brand: '',
    description: 'SMS Marketing Platform build for eCommerce',
    plan: ' Free plan available',
    star: 0,
    review: '',
    img: smsg,
    href: 'https://apps.shopify.com/smsgem-subscribers?locale=fr&utm_campaign=synctrack&utm_content=button&utm_medium=banner&utm_source=referral',
  },
  {
    title: 'Snap! Request Quote Hide Price',
    brand: '',
    description:
      'Let customer request for quote easily with button & hide price',
    plan: 'Free plan available',
    star: '4.8',
    review: '242',
    img: requestaquote,
    href: 'https://apps.shopify.com/request-for-quote-by-omega?locale=fr&utm_campaign=synctrack&utm_content=button&utm_medium=banner&utm_source=referral',
  },
  {
    title: 'Trustoo.io Reviews Product',
    brand: '',
    description: 'Translate reviews, Import from AliExpress...',
    plan: 'Free plan available',
    star: '5',
    review: '828',
    img: vsali,
    href: 'https://apps.shopify.com/sealapps-product-review?from=Synctrackhome&utm_campaign=crossPromote&utm_medium=home&utm_source=Synctrack',
  },
  {
    title: 'Be Yours theme ',
    brand: 'RoarTheme',
    brandURL: 'https://roartheme.co/?utm_source=omega&utm_medium=in_app_banner',
    description:
      'Create super fast responsive websites with an amazing user experience.',
    plan: '',
    star: 0,
    review: '',
    img: roartheme,
    href: 'https://themes.shopify.com/themes/be-yours?utm_source=omega&utm_medium=in_app_banner',
  },
  {
    title: 'B2B/Wholesale Solution',
    brand: '',
    description:
      'All-in-one B2B Wholesale Solution: Custom Pricing, VAT, Form..',
    plan: 'Free plan available',
    star: 5,
    review: '246',
    img: b2b,
    href: 'https://apps.shopify.com/b2b-solution-custom-pricing?utm_source=syntrack&utm_medium=inapppromotion&utm_campaign=partnershipttps://themes.shopify.com/themes/be-yours?utm_source=omega&utm_medium=in_app_banner',
  },
  {
    title: 'Discount BOGO and Free Gift',
    brand: '',
    description:
      'Buy X Get Y, Free Gift, Flash Sale, Cart Conditional Discount',
    plan: 'Free plan available',
    star: 5,
    review: '29',
    img: bogo,
    href: 'https://apps.shopify.com/discos-smart-bogo-cart-upsell?utm_source=synctrack+recommended+app&utm_medium=partner+program&utm_campaign=wizz_synctrack',
  },
  {
    title: 'litCommerce',
    brand: 'LitExtension',
    description:
      'The most easy-to-use and affordable multichannel selling solution',
    plan: '',
    star: 0,
    review: '',
    img: litcommerce,
    href: 'https://litcommerce.com/?utm_source=synctrackapp&utm_medium=in_app&utm_campaign=aff',
  },
];
